import React from 'react';

export const HALF_WIDTH = { upper: 29.5, lower: 31 };

export const NAME = { upper: 'Birinchi katta oziq tish', lower: 'Birinchi katta oziq tish' };

/*
 * Upper first molar: the largest tooth of the arch. Three divergent roots — a
 * broad mesio-buccal, a narrower disto-buccal and the long palatal one between
 * them — splitting right below a short root trunk. The occlusal outline shows
 * the two buccal cusps plus the palatal cusp tip, separated by the buccal
 * groove and the distal fissure.
 */
const UPPER_OUTLINE = `M 28 44
    C 24 52 21.2 58.4 20.6 66
    C 20.2 74 22.4 82 25.4 86.4
    C 27 88.6 28.6 90.6 30.6 92.2
    C 32.6 93.8 35.4 94.4 37.2 92.8
    C 39.2 91 41 89.4 42.6 88.6
    C 43.6 88.1 44 88.1 44.8 88.7
    C 46.6 90 48.4 91.8 50.4 93
    C 52.6 94.4 55 93.8 56.6 92.2
    C 58 90.8 59.4 89.4 60.6 88.6
    C 61.4 88.1 61.9 88.2 62.6 88.8
    C 64.4 90.2 66.4 91.8 68.2 92.6
    C 70.2 93.5 72 92.4 73.4 89.8
    C 76.6 84.8 79.2 74.4 79.4 66
    C 79.6 57.6 76.4 50 72 44
    C 71.6 40 71.6 34 72 28
    C 72.2 22.4 71.4 17 69.4 15
    C 67.4 13 64.4 14.6 63.4 18.8
    C 62.4 23 61.6 29.4 61 34.4
    C 60.6 36.6 60 37.8 59.2 38.4
    C 58.6 37.2 58.2 35.4 57.8 32.6
    C 57 25.4 56 15.4 55.2 10.6
    C 54.4 6.8 50.4 6 48.2 8.8
    C 46 11.6 45 21.4 44.2 30.4
    C 43.8 34 43.2 37 42 38.4
    C 41 37.4 40.4 35.6 39.8 32.8
    C 38.6 26 37 18 35.2 15.4
    C 33.2 12.6 29.6 13.6 28.4 18
    C 27.4 22 27.6 28 28 34
    C 28.2 38 28 41.4 28 44 Z`;

const UPPER_CERVICAL = 'M 28 44 C 36 38 64 38 72 44';

const UPPER_DETAILS = [
    /* Buccal groove and distal fissure of the occlusal table. */
    'M 43.8 88.3 C 43.4 82 43.2 75 43.8 68',
    'M 61.6 88.4 C 61.4 82.4 61.4 76 61.8 70',
    /* Cusp ridges. */
    'M 34.4 93.8 C 34.8 87 35 80.4 34.6 74.4',
    'M 53 93.8 C 53.4 87.4 53.6 81.4 53.2 76',
    /* Furcation lines running from the root splits into the trunk. */
    'M 42 38.4 C 41.2 40.6 40.6 42.4 40.2 44.2',
    'M 59.2 38.4 C 59.8 40.6 60.2 42.4 60.6 44.2',
];

/*
 * Lower first molar: a wide five-cusped crown — three cusps show in the buccal
 * outline, divided by the mesio-buccal and disto-buccal grooves — carried by
 * two well separated roots, the mesial one broader and grooved.
 */
const LOWER_OUTLINE = `M 29 50
    C 25.4 40 21.6 30 20.6 22
    C 20.2 15.4 22.4 9.4 26 6.6
    Q 28.4 4.6 31.8 5.4
    L 35.6 4.2
    Q 37.8 3.4 39.2 5.4
    L 43.6 11.4
    Q 44.8 12.8 46 11.4
    L 50.6 5.6
    Q 52.8 3.4 55 5.6
    L 59.6 11
    Q 60.8 12.2 62 10.8
    L 66 5.4
    Q 68.2 3.2 70.4 5.6
    C 74.4 9 77.2 15.4 77.4 22.4
    C 77.6 30.4 74.2 40 71 50
    C 72.8 58 73.4 68 72.4 77
    C 71.6 84.6 69.8 90.6 67 93
    Q 63.4 96 59.6 94.4
    C 56.6 93.2 54.4 88.6 53 82
    C 51.6 75.4 50.8 66 50.4 59.4
    C 50.3 58 50.2 57.4 50 57
    C 49.8 57.4 49.7 58 49.6 59.4
    C 49.2 66 48.4 75.4 47 82
    C 45.6 88.6 43.4 93.2 40.4 94.4
    Q 36.6 96 33 93
    C 30.2 90.6 28.4 84.6 27.6 77
    C 26.6 68 27.2 58 29 50 Z`;

const LOWER_CERVICAL = 'M 29 50 C 37 55.6 63 55.6 71 50';

const LOWER_DETAILS = [
    /* Mesio-buccal and disto-buccal grooves. */
    'M 44.8 11.8 C 44.4 19 44.2 27 44.8 34',
    'M 61.2 11.4 C 61 18.6 61 26 61.4 33',
    /* Cusp ridges. */
    'M 36.4 5.4 C 36.8 12.4 37 19 36.6 25',
    'M 52.8 5.8 C 53.2 12.6 53.4 19 53 25',
    /* Root trunk above the bifurcation and the mesial root groove. */
    'M 50 57 C 50 54.4 50 52.2 50 50.2',
    'M 39.6 60 C 39.8 70 39.6 80 38.8 88',
];

export default function FirstMolar({ jaw }) {
    const isUpper = jaw === 'upper';

    return (
        <>
            <path d={isUpper ? UPPER_OUTLINE : LOWER_OUTLINE} className="dental-tooth__body" />
            <path d={isUpper ? UPPER_CERVICAL : LOWER_CERVICAL} className="dental-tooth__line" />
            {(isUpper ? UPPER_DETAILS : LOWER_DETAILS).map((d) => (
                <path key={d} d={d} className="dental-tooth__detail" />
            ))}
        </>
    );
}
